<template>
  <button
    type="button"
    class="[ toggle ] relative flex shrink-0 items-center justify-normal gap-x-1 w-12 h-6 py-0 px-0.5 bg-stone-300 rounded-full cursor-pointer ml-auto"
    :class="{
      'toggle--on': isOn,
      'toggle--off': !isOn,
      'toggle--disabled': disabled
    }"
    :style="isOn ? { backgroundColor: color } : {}"
    :disabled="disabled"
    @click="onToggle">
    <span v-if="labels" class="[ toggle__label ]">{{ isOn ? 'On' : 'Off' }}</span>
    <span class="[ toggle__thumb ] absolute left-1 top-1 w-4 h-4 rounded-full bg-white" />
  </button>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({ name: 'ToggleButton' });

const props = defineProps({
  value: {
    type: [Boolean, String],
    default: false
  },
  color: {
    type: String,
    default: '#16a34a'
  },
  labels: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['change']);

const isOn = computed(() => props.value === true || props.value === 'true');

const onToggle = () => {
  if (props.disabled) return;
  emit('change', !isOn.value);
};
</script>

<style scoped>
.toggle {
  border: 1px solid rgba(0, 0, 0, 0.1);
  transition: background-color 150ms ease, opacity 150ms ease;
}

.toggle__thumb {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: transform 150ms ease;
  transform: translateX(0);
}

.toggle--on .toggle__thumb {
  transform: translateX(1.5rem);
}

.toggle__label {
  padding-top: 2px; /* the parent div is a flex, which centers elements, but somehow this padding is nevertheless necessary => ugly! */
  line-height: 8px;
  display: flex;
  position: relative;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 8px;
  color: white;
  transform: translateX(0.1rem);
}

.toggle--off .toggle__label {
  color: rgb(107 114 128);
  transform: translateX(1.4rem);
}

.toggle--disabled {
  /* opacity: 0.5; */
  cursor: not-allowed;
}
</style>
